export default "__VITE_ASSET__1fb8f6c4__"